import React from "react";
import styled from "styled-components";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

export const measurementMap = {
  neck: 'Neck',
  chest: 'Chest',
  bust: 'Bust',
  waist_natural: 'Waist (natural)',
  waist_belly: 'Waist (belly button)',
  hips: 'Hips',
  left_bicep: 'Bicep left',
  right_bicep:  'Bicep right',
  left_forearm: 'Forearm left',
  right_forearm: 'Forearm right',
  left_thigh: 'Thigh left',
  right_thigh: 'Thigh right',
  left_calf: 'Calf left', 
  right_calf: 'Calf right',
  chest_skinfold: 'Chest',
  axilla_skinfold: 'Axilla',
  tricep_skinfold: 'Tricep',
  subscapular_skinfold: 'Subscapular',
  abdominal_skinfold: 'Abdominal',
  suprailiac_skinfold: 'Suprailiac',
  thigh_skinfold: 'Thigh',
}

const Title = styled.h2`
  margin: 20px 0px;
`;

const Row = styled.div`
  border-radius: 16px;
  box-shadow: 0 0 33px rgb(137 156 197 / 17%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  margin: 4px 0px;
  min-width: 400px;
  width: 100%;

  @media(max-width: 620px) {
    min-width: unset;
  }

  p {
    font-size: 1.125rem;
    margin: 0;
  }

  p:nth-child(1) {
    font-weight: bold;
  }

  p:nth-child(2) {
    font-size: 1.25rem;
    color: #86929f;
  }
`;

const DataRow = ({name, value}) => {
  return (
    <Row>
      <p>{measurementMap[name]}</p>
      <p>{name.includes('skinfold') ? `${value} mm` : `${(value / 2.54).toFixed(0)} inches`}</p>
    </Row>
  )
}

export const MeasurementModal = ({open, onClose, data}) => {  
  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
    >
      {data &&
        <DialogContent className="avn-modal-content-container">
          <Title>Measurements for {data.date} check-in</Title>
          {Object.keys(data.data.data).map((m, id) => {
            return (
              <DataRow 
                key={m}
                name={m}
                value={data.data.data[m]}
              />
            )
          })}
        </DialogContent>
      }
      <DialogActions className='avn-modal-actions-container'>
        <button
          className="avn-modal-action"
          onClick={() => onClose()}
        >
          Close
        </button>
      </DialogActions>
    </Dialog>
  )
}

